module.exports = __webpack_public_path__ + "img/1512894380.d08e02be.jpg";